export const THEME = {
  COLORS: {
    PRIMARY: "#D8372C",
    SECONDARY: "#0857A8",
    WHITE: "#F2F2F2",
  }
}